import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Box, Grid, Card, Container, Typography, Button } from "@mui/material";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';
import Home from "../nongjok/Home";
import StatusMachine from "../nongjok/Status_machine";
import Report from "../nongjok/Report";



function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function OEEDashboardTab() {
    const [value, setValue] = useState(0);


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const StyledTab = styled(Tab)({
        "&.Mui-selected": {
            color: "red"
        }
    });


    return (

        <div className="App">
            <Helmet>
                <title>Overview | MES</title>
            </Helmet>
            <Grid
                container
                style={{ paddingTop: 0, backgroundColor: '#e0f2f1' }}
            >
                <Grid item lg={12} md={12} sm={12} xl={12} xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Box sx={{ width: '100%' }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" >
                                <Tab label="Home" {...a11yProps(0)} />
                                <Tab label="Status Machine" {...a11yProps(1)} />
                                <Tab label="Report" {...a11yProps(2)} />
                            </Tabs>
                        </Box>                       
                        <CustomTabPanel value={value} index={0}>
                            <Home />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={1}>
                            <StatusMachine />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={2}>
                            <Report />
                        </CustomTabPanel>
                    </Box>
                </Grid>
            </Grid>
        </div>
    );
}





